import React, {useState, useEffect, useRef} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import Config from "../../core/config";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import Cookies from "js-cookie";
import {useNavigate} from "react-router-dom";

const apiUrl = Config.apiUrl;
const PaymentMethodList = () => {
    let [paymentMethods, setPaymentMethods] = useState([]);
    const [queryString, setQueryString] = useState('');
    const [openMenuId, setOpenMenuId] = useState(null);
    const inputQueryString = useRef(null);
    const openMenuRef = useRef(null);
    const [, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();

    async function makeQuery(query) {
        try {
            setLoading(true);
            const url = apiUrl + '/api/paymentMethods/query=' + (query && query !== '' ? (query) : '');
            const response = await makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
            setPaymentMethods(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (inputQueryString.current) {
            inputQueryString.current.focus();
        }
        makeQuery('');
    }, []);

    useEffect(() => {
        function handleOutsideClick(event) {
            if (openMenuRef.current && !openMenuRef.current.contains(event.target)) {
                setOpenMenuId(null);
            }
        }

        document.addEventListener('mousedown', handleOutsideClick);
        return () => document.removeEventListener('mousedown', handleOutsideClick);
    }, []);

    const handleInputChange = (e) => {
        const string = e.target.value;
        if (string.length >= 3 || string.length === 0) {
            makeQuery(string);
        }
        setQueryString(string);
    };

    function toggleMenu(paymentMethodId) {
        setOpenMenuId((prevState) => (prevState === paymentMethodId ? null : paymentMethodId));
    }

    async function removePaymentMethod(id) {
        try {
            setLoading(true);
            const url = apiUrl + '/api/paymentMethods/' + id;
            await makeRequest(url, 'DELETE', {'Useruuid':Cookies.get('userUUID')});
            await makeQuery(queryString);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <div className="header-label">Consulta de Formas de Pagamento</div>
            <div
                style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                <input ref={inputQueryString} type="text" value={queryString} onChange={handleInputChange}/>
                <button onClick={() => navigate('/paymentmethod')}>Novo</button>            </div>
            <table className="payment-method-list-table" style={{width: '400px'}}>
                <colgroup>
                    <col style={{width: '60px'}}/>
                    <col/>
                    <col style={{width: '40px'}}/>
                </colgroup>

                <thead>
                <tr>
                    <th>Código</th>
                    <th>Nome</th>
                    <th/>
                </tr>
                </thead>

                <tbody style={{overflowY: 'auto'}}>
                {paymentMethods.map((paymentMethod, index) => (
                    <tr key={index}>
                        <td>{paymentMethod.code}</td>
                        <td>
                            <div className="payment-method-name-cell">{paymentMethod.name}</div>
                        </td>
                        <td>
                            <div
                                className="kebab-menu-container"
                                ref={openMenuId === paymentMethod.id ? openMenuRef : null}
                            >
                                <button
                                    className="kebab-menu-button"
                                    onClick={() => toggleMenu(paymentMethod.id)}
                                    aria-label="Ações"
                                >
                                    ⋮
                                </button>
                                {openMenuId === paymentMethod.id && (
                                    <ul className="kebab-menu">
                                        <li>
                                            <button
                                                className="kebab-menu-item"
                                                onClick={async () => {
                                                    setOpenMenuId(null);
                                                    await navigate('/paymentmethod?id=' + paymentMethod.id);
                                                }}
                                            >
                                                Editar
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                className="kebab-menu-item remove-button"
                                                onClick={async () => {
                                                    setOpenMenuId(null);
                                                    if (window.confirm('Deseja realmente excluir?')) {
                                                        await removePaymentMethod(paymentMethod.id);
                                                    }
                                                }}
                                            >
                                                Excluir
                                            </button>
                                        </li>
                                    </ul>
                                )}
                            </div>
                        </td>
                    </tr>
                ))}
                {paymentMethods.length === 0 && <tfoot>Nenhum item encontrado.</tfoot>}
                </tbody>
            </table>
        </>
    );
};

export default PaymentMethodList;
